module.exports = __webpack_public_path__ + "static/media/container9.e7cb39fc.jpg";